import { Instance, SnapshotOut } from 'mobx-state-tree';
import WidgetProcessor from '~/mst/models/widget/processor';
import actions from './actions';
import model from './model';
import views from './views';

const WindRoseWidgetStore = model.views(views).actions(actions);

export interface IWindRoseWidgetStore extends Instance<typeof WindRoseWidgetStore> {}
export interface IWindRoseWidgetStoreSnapshotOut extends SnapshotOut<typeof WindRoseWidgetStore> {}

export default WidgetProcessor(WindRoseWidgetStore);
